import { DateRange, Timestamp } from "../../../types";
import { getDateStr } from "../../../utils";
import { ISCDailyID, ISCDataset, ISCMonthlyID, ISCRangeMap, ISCResponseData } from "./types";

export const parseISCResponseData = <T extends keyof ISCRangeMap>(
  dateRange: DateRange,
  range: T,
  data: unknown[]
): ISCDataset => {
  let res: ISCDataset = [];

  (data as ISCResponseData<T>[]).forEach((d) => {
    res.push({
      received_sum: d.received_sum,
      spent_sum: d.spent_sum,
      _id: parseISCID(range, d._id),
    });
  });

  return res;
};

export const parseISCID = <T extends keyof ISCRangeMap>(
  range: T,
  _id: ISCRangeMap[T]
): Timestamp => {
  if (range === "daily") {
    const id = _id as ISCRangeMap["daily"];
    return new Date(parseISCDailyID(id)).getTime();
  } else if (range === "monthly") {
    const id = _id as ISCRangeMap["monthly"];
    return new Date(parseISCMonthlyID(id)).getTime();
  }

  return 0;
};

export const formatID = (
  range: keyof ISCRangeMap,
  value: Timestamp
): string => {
  switch (range) {
    case "daily":
      return getDateStr(value);
    case "monthly":
      return getDateStr(value);
    default:
      return "unknown format!";
  }
};

export const parseISCDailyID = (id: ISCDailyID): Timestamp => {
  let p = id.split("-") as unknown as number[];
  return new Date(p[0], p[1] - 1, p[2]).getTime();
}

export const parseISCMonthlyID = (id: ISCMonthlyID): Timestamp => {
  let p = id.split("-") as unknown as number[];
  return new Date(p[0], p[1] - 1).getTime();
}